  document.addEventListener('DOMContentLoaded', function() {
    let dataColors = [];
    let colorsJson = window.theme.assets.swatches;
    fetch(colorsJson)
      .then(response => {
        // Check if the response is ok (status code in the range 200-299)
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        // Parse the JSON data
        return response.json();
      })
      .then(data => {
        // Use the retrieved data
        // Function to get hex value by color name
        // Example usage
        dataColors = data.colors;
      })
      .catch(error => {
        // Handle any errors
        console.error('There was a problem with the fetch operation:', error);
      });
    console.log(dataColors, 'dataColors');
    function initVariant(){
      let mattressProductTitle = document.querySelector('.mattress-product-title').value;
      console.log(mattressProductTitle, 'mattressProductTitle');
      switch (mattressProductTitle) {
        case 'cooling-hybrid-mattress':
          document.querySelector('#zinusPremierRadio--2 input').checked = true;
          document.querySelector('#materialHybrid input').checked = true;
          document.querySelector('#zinusOriginalRadio').classList.add('hidden');
          document.querySelector('#zinusPremierRadio--3').classList.remove('opacity');
          document.querySelector('#zinusPremierRadio--2').classList.remove('opacity');
          break;
        case 'original-hybrid-mattress':
          document.querySelector('#zinusOriginalRadio input').checked = true;
          document.querySelector('#materialHybrid input').checked = true;
          document.querySelector('#zinusPremierRadio--3').classList.add('hidden');
          document.querySelector('#zinusOriginalRadio').classList.remove('opacity');
          document.querySelector('#zinusPremierRadio--2').classList.remove('opacity');
          break;
        case 'ultra-hybrid-mattress':
          document.querySelector('#materialHybrid input').checked = true;
          document.querySelector('#zinusPremierRadio--3 input').checked = true;
          document.querySelector('.pdp-variant-1-text').classList.add('hidden');
          document.querySelector('#zinusOriginalRadio').classList.add('hidden');
          document.querySelector('#zinusPremierRadio--2').classList.add('hidden');
          document.querySelector('#zinusPremierRadio--3').classList.add('hidden');
          break;
        case 'original-green-tea':
          document.querySelector('#zinusOriginalRadio input').checked = true;
          document.querySelector('#materialMemoryFoam input').checked = true;
          document.querySelector('#zinusPremierRadio--3').classList.add('hidden');
          document.querySelector('#zinusOriginalRadio').classList.remove('opacity');
          document.querySelector('#zinusPremierRadio--2').classList.remove('opacity');
          break;
        case 'ultra-green-tea':
          document.querySelector('.pdp-variant-1-text').classList.add('hidden');
          document.querySelector('#materialMemoryFoam input').checked = true;
          document.querySelector('#zinusPremierRadio--3 input').checked = true;
          document.querySelector('#zinusOriginalRadio').classList.add('hidden');
          document.querySelector('#zinusPremierRadio--2').classList.add('hidden');
          document.querySelector('#zinusPremierRadio--3').classList.add('hidden');
          break;
        case 'cooling-green-tea':
          document.querySelector('#zinusPremierRadio--2 input').checked = true;
          document.querySelector('#materialMemoryFoam input').checked = true;
          document.querySelector('#zinusOriginalRadio').classList.add('hidden');
          document.querySelector('#zinusPremierRadio--3').classList.remove('opacity');
          document.querySelector('#zinusPremierRadio--2').classList.remove('opacity');
          break; 
        default:
      }
    }
    document.querySelectorAll('.product-media__image').forEach(media => {
      media.addEventListener('click', function(){
        if(media.classList.contains('active')){
          media.classList.remove('active');
        }else{
          media.classList.add('active');
        }
        media.addEventListener('mousemove', function zoomImage(event){
          zoom(event);
        })
      })
    })
    function toggleVariant() {
      document.querySelector('.select-popout__toggle').addEventListener('click', function(){
          console.log("---clickeed")
        var isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);
        document.querySelector('.zin-select-popout__list').classList.toggle('select-popout__list--visible');
      })
    }

    function zoom(e){
      var zoomer = e.currentTarget;
      e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
      e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
      x = offsetX/zoomer.offsetWidth*100
      y = offsetY/zoomer.offsetHeight*100
      zoomer.style.backgroundPosition = x + '% ' + y + '%';
    }



    function customWidget(variantId) {
      let dataId = document.querySelector('.cross_products-wrapper')?.dataset.widgetId;
      let variantID = variantId;
      let productId = document.querySelector('custom-product').dataset.productId;
      let matchOption = document.querySelector('.select-popout__item--current span')?.textContent.trim();
      let dataUrl = `https://rebuyengine.com/api/v1/custom/id/${dataId}?key=497cd4712d15cfb2f8690d77b13f74779fbb6bf8&shopify_product_ids=${productId}&shopify_variant_ids=${variantID}&metafields=yes`;
      console.log(dataUrl, 'dataUrl');
      fetch(dataUrl)
        .then(response => response.json())
        .then(data => {
          let crossProducts = data.data;
          // console.log(data, 'data');
          console.log(crossProducts, 'crossProducts');
          let productsBody = '';
          crossProducts.forEach(item => {
            let descriptions = '';
            let hideVariants = '';
            if(item.metafields){
              item.metafields.forEach(metafield => {
                if(metafield.key == "cross_description"){
                  descriptions = metafield.value;
                }
              })
            }

            if(item.id == '7691544461375'){
              hideVariants = 'hidden';
            }
            
            productsBody += `<div class="product__form" data-product-part="">
                    <input type="hidden" name="id" value="${item.variants[0].id}" data-product-select="" data-product-available="true">
                    <div class="cross_product-item" data-product-id="${item.id}" data-handle="${item.handle}">
                    <div class="cross_product-image">
                      <img src="${item.image.src}" width="100" height="100" alt="${item.image.alt}">
                    </div>
                    <div class="cross_product-details" data-variant-sku="${item.variants[0].sku}">
                      <div class="title-with-price">
                        <button class="cross_product-checked">
                          <span class="icon-plus">
                            <svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m13.5113 6.026h-5.53803v-5.538h-1.924v5.538h-5.563996v1.924h5.563996v5.564h1.924v-5.564h5.53803z" fill="currentColor"></path></svg>
                          </span>
                          <span class="add_button">Add</span>
                        </button>
                        <label for="cross_product">` +
                        item.variants.map((card, index) => {
                          console.log(item.id, 'item.id');
                            let option = '';
                            let hideComparePrice = '';
                            let variantName = card.title;
                            if (!card.title.includes(matchOption) || index > 0) {
                              option = 'hidden';
                            }
                            
                            if (card.compare_at_price === card.price || !card.compare_at_price) {
                                hideComparePrice = 'hidden';
                            }
                            return `<div class="price-wrapper ${option}" data-variant-name='${variantName}' data-variant-id="${card.id}" data-inventory-quantity="${card.inventory_quantity}">
                                        <span class='product_title'>${item.title}</span>
                                        <div class="variant-with-price">
                                            <span class='variant_option'>(${matchOption})</span>
                                            <span class="variant_price" data-price="${card.price}">$${card.price}</span>
                                            <span class="product__price--compare ${hideComparePrice}">$${card.compare_at_price}</span>
                                        </div>
                                    </div>`;
                        }).join('') + `</label>
                        </div>
                        <div class="item_options ${hideVariants}">`+
                            item.options.map(option => {
                              if(option.name.trim() != 'Size' && option.name.trim() != 'size'){
                                if(option.name.trim() == 'Color'){
                                  let returnText = `<fieldset class="radio__fieldset">`
                                  for(index in option.values){
                                    let colorName = option.values[index].toLowerCase(); // Change this to any color name you want
                                    let hexValue = getHexValue(dataColors, colorName);
                                    let currentItem = '';
                                    let optionValue = option.values[index].replace(' ', '-');
                                    let input_id = `${option.id}-${option.product_id}-${option.name}-${optionValue}`;
                                    let name = `${option.name}--${option.product_id}`;
                                    if(index == 0){
                                      currentItem = 'checked';
                                    }
                                    returnText += `<span class="swatch__button"><input type="radio"
                                      class="swatch__input variant_radio_input"
                                      data-single-option-selector
                                      data-index="option"
                                      name="${name}"
                                      value="${option.values[index]}"
                                      id="${input_id}"
                                      ${currentItem}>
                                      <label for="${input_id}" class="swatch__label" data-swatch="${option.values[index]}" data-tooltip="${option.values[index]}" style="background-color: ${hexValue};">
                                      <span class="visually-hidden">${option.values[index]}</span>
                                    </label></span>`
                                  }
                                  returnText += `</fieldset>`
                                  return returnText;
                                }else{
                                  let returnText = `<div class="select-popup__item"><button type="button" class="select-popout__toggle" aria-expanded="false"><span class="select-popout__value" data-popout-text>${option.values[0]}
                                  </span><svg xmlns="http://www.w3.org/2000/svg" class="icon-select" width="24" height="24" viewBox="0 0 24 24">
                                    <polygon points="12 17.414 3.293 8.707 4.707 7.293 12 14.586 19.293 7.293 20.707 8.707 12 17.414"/>
                                  </svg></button><div class="select-popout__list" data-popout-list><ul class="select-popout__list__scroll">`
                                  for(index in option.values){
                                    let currentItem = '';
                                    if(index == 0){
                                      currentItem = 'select-popout__item--current';
                                    }
                                    returnText += `<li class="select-popout__item ${currentItem}">
                                                    <a class="select-popout__option" href="#" data-value='${option.values[index]}' data-popout-option>
                                                      <span value="${option.values[index]}">${option.values[index]}</span>
                                                    </a>
                                                  </li>`
                                  }
                                  returnText += `</ul></div></div>`
                                  return returnText;
                                }
                              }
                          }).join('')+
                        `</div>
                        <div class="cross_product-description"><p>${descriptions}</p></div>
                      </div>
                    </div></div>`;
        });
        
          document.querySelector('.cross_products-wrapper').innerHTML = productsBody;
          productWidget();
          document.querySelectorAll('.rebuy_cross-wrapper .cross_product-item').forEach(item => {
            let popoutText = document.querySelector('.select-popout__item--current span').textContent.trim();
            let variantTitle = item.querySelector(`.title-with-price label .price-wrapper`).dataset.variantName;
            if(variantTitle.includes(popoutText)){
              item.classList.remove('hidden');
            }else{
              item.classList.add('hidden');
            }
            if(item.querySelector('.title-with-price .price-wrapper:not(.hidden)').dataset.inventoryQuantity < 1){
              item.classList.add('hidden');
            }
          })

          rebuyOptionSelector();
        });
    }

    function getHexValue(dataColors, colorName) {
      // Loop through each object in the array
      for (const color of dataColors) {
        // Check if the color name exists in the object
        if (color[colorName]) {
          return color[colorName]; // Return the hex value
        }
      }
      
    }

    async function checkForMulberryToken(ms = 100, triesLeft = 100) {
      return new Promise((resolve, reject) => {
        if (window?.mulberry?.core?.publicToken) {
          resolve(true);
        }
        const interval = setInterval(async () => {
          if (window?.mulberry?.core?.publicToken) {
            resolve(true);
            clearInterval(interval);
          } else if (triesLeft <= 1) {
            resolve(false);
            clearInterval(interval);
          }
          triesLeft--;
        }, ms);
      });
    }

    async function initializeMulberry(variantTitle, variantPrice, variantSku, variantId, container) {
      document.querySelector('.rebuy-mulberry-inline').innerHTML = '';
      if(document.querySelector('.popup-mulberry-inner'))
        document.querySelector('.popup-mulberry-inner').innerHTML = '';
      document.querySelector('.rebuy-mulberry-inline_wrapper .mulberry-id').innerHTML = '';
      document.querySelectorAll('.mulberry-product-id').forEach(item =>{
        item.value='';
      })
      if(document.querySelector('.rebuy_popup-wrapper .mulberry-id')){
        document.querySelector('.rebuy_popup-wrapper .mulberry-id').innerHTML = '';
      }
      window.mulberry.core.init({
        publicToken: 'zLHKJyjbN1MyxRnXHwSvcgq-gMk'
      });
      async function setMulberrySelectedWarranty(warranty){
        let mulberrySelectedWarranty = warranty;
        if (mulberrySelectedWarranty) {
          try {
            // Prepare the request parameters
            const params = new URLSearchParams({
              product_price: mulberrySelectedWarranty.product.price,
              duration_months: mulberrySelectedWarranty.duration_months,
              insurer_category: mulberrySelectedWarranty.insurer_category
            });
        
            // Await the fetch call
            const response = await fetch(`https://ottawa.getmulberry.com/api/prices?${params}`, {
              method: 'GET',
              headers: {
                'Authorization': 'Bearer zLHKJyjbN1MyxRnXHwSvcgq-gMk',
                'Content-Type': 'application/json' // Optional
              }
            });
        
            // Check if the response is OK
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
        
            // Await the JSON parsing
            const data = await response.json();
            const shopifyMulberryVariantId = data.shopify_variant_id;
            console.log(shopifyMulberryVariantId, 'data');
            document.querySelector('.rebuy-mulberry-inline_wrapper .mulberry-id').innerHTML = `<input type="hidden" name="items[1][id]" value="${shopifyMulberryVariantId}" data-mulberry-id>`;
            document.querySelectorAll('.mulberry-product-id').forEach(item =>{
              item.value=shopifyMulberryVariantId;
            })
            if(document.querySelector('.rebuy_popup-wrapper .mulberry-id'))
              document.querySelector('.rebuy_popup-wrapper .mulberry-id').innerHTML = `<input type="hidden" name="items[1][id]" value="${shopifyMulberryVariantId}" data-mulberry-id>`;
          } catch (error) {
            console.error('Unable to fetch mulberry variant ID', error);
          }
        }else{
          document.querySelector('.rebuy-mulberry-inline_wrapper .mulberry-id').innerHTML = '';
          if(document.querySelector('.rebuy_popup-wrapper .mulberry-id')){
            document.querySelector('.rebuy_popup-wrapper .mulberry-id').innerHTML = '';
          }
        }
      }

      checkForMulberryToken();
    
      const offers = await mulberry.core.getWarrantyOffer({
        title: variantTitle,
        id: variantSku,
        price: variantPrice
      });
      document.querySelector('.mulberry-popup [data-product-id]').value = variantId;
      console.log(offers, 'offers');
      mulberry.inline.init({
        offers: offers,
        settings: mulberry.core.settings,
        selector: container,
        onWarrantyToggle: warranty => {
          console.log('warranty', warranty);
          if (warranty.isSelected) {
            return setMulberrySelectedWarranty(warranty.offer);
          }

          setMulberrySelectedWarranty(null);
        }
      });
      if(container == '.rebuy-mulberry-inline'){
        setTimeout(() => {
          document.querySelector('.mulberry-popup').classList.add('active');
        }, 1000);
      }
    }

    function productWidget(){
      document.querySelectorAll('.rebuy_cross-wrapper .cross_product-checked').forEach((item, index) => {
        item.addEventListener('click', function(e){
          let productId = item.closest('.cross_product-item').dataset.productId;
          if(item.classList.contains('button_clicked')){
            document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
              card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.remove('button_clicked');
              card.querySelector('.add_button').textContent = 'Add';
            })
            e.preventDefault();
            e.stopPropagation();
            if(document.querySelector(`.cart-drawer__items .cart__item__content[data-item-id="${productId}"]`).querySelector('.cart__item__remove'))
              document.querySelector(`.cart-drawer__items .cart__item__content[data-item-id="${productId}"]`).querySelector('.cart__item__remove').click();
          }else{
            document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
              card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.add('button_clicked');
              card.querySelector('.add_button').textContent = 'Added';
            })
            let variantTitle = item.closest('.cross_product-details').querySelector('.product_title').textContent.trim();
            let variantPrice = item.closest('.cross_product-details').querySelector('.variant-with-price .variant_price').dataset.price;
            let variantSku = item.closest('.cross_product-details').dataset.variantSku;
            let variantId = item.closest('[data-product-part]').querySelector('[data-product-select]').value;
            let container = '.rebuy-mulberry-inline';
            initializeMulberry(variantTitle, variantPrice, variantSku, variantId, container);
            document.querySelector('.close_mulberry_popup').addEventListener('click', function(){
              document.querySelector('.mulberry-popup').classList.remove('active');
              
              document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
                card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.remove('button_clicked');
                card.querySelector('.add_button').textContent = 'Add';
              })
            })
            document.querySelector('.mulberry-add-button').addEventListener('click', function(){
              document.querySelector('.mulberry-popup').classList.remove('active');
            })

            document.querySelector('.purchase_button').addEventListener('click', function(){
              document.querySelector('.rebuy-mulberry-inline_wrapper .mulberry-id').innerHTML = '';
              document.querySelector('.mulberry-add-button').click();
            })
          }   
          // addToCart(productId, 1);

        })
      })
    }

    function productPopupWidget(){
      document.querySelectorAll('.rebuy_popup-wrapper .cross_product-checked').forEach((item, index) => {
        item.addEventListener('click', function(e){
          let productId = item.closest('.cross_product-item').dataset.productId;
          if(item.classList.contains('button_clicked')){
            document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
              card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.remove('button_clicked');
              card.querySelector('.add_button').textContent = 'Add';
            })
            e.preventDefault();
            e.stopPropagation();
            if(document.querySelector(`.cart-drawer__items .cart__item__content[data-item-id="${productId}"]`).querySelector('.cart__item__remove'))
              document.querySelector(`.cart-drawer__items .cart__item__content[data-item-id="${productId}"]`).querySelector('.cart__item__remove').click();
          }else{
            document.querySelector('.rebuy-mulberry-inline').innerHTML = '';
            document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
              card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.add('button_clicked');
              card.querySelector('.add_button').textContent = 'Added';
            })
            
          }

          // addToCart(productId, 1);

        })
      })
    }

    initSwiper();

    initVariant();

    swapProduct();
    
    quickView();

    let variantTotalPrice= [];

    document.querySelectorAll('.variants-wrapper .variant_item').forEach(variantItem => {
      variantTotalPrice.push(variantItem.dataset.totalValue);
    })

    document.querySelectorAll(".select-popout__list__scroll .price-with-total").forEach((item, i) => {
      if (!variantTotalPrice[i].includes('$0.00')) {
        item.querySelector('.total_price').innerHTML = `( total value ${variantTotalPrice[i]})`;
      }
    })

    document.querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(button => {
      button.addEventListener('click', function(e){
        let popoutText = this.querySelector('.select-popout__option').dataset.value;
        let optionPrice = this.querySelector('.option_price').innerHTML;
        
        console.log(popoutText, 'popoutText');
        if(document.querySelector('.cross_products-wrapper')){
          document.querySelectorAll('.cross_products-wrapper .cross_product-item').forEach(item => {
            item.querySelector('.variant-with-price .variant_option').textContent = popoutText;
            item.querySelectorAll('.title-with-price label .price-wrapper').forEach(card => {
              card.classList.add('hidden');
            })
            if(item.querySelector(`.title-with-price label .price-wrapper[data-variant-name = ${popoutText}]`)){
              item.classList.remove('hidden');
              item.querySelector(`.title-with-price label .price-wrapper[data-variant-name = ${popoutText}]`).classList.remove('hidden');
            }else{
              item.classList.add('hidden');
            }
          })

          document.querySelectorAll('.cross_product-item').forEach(item => {
            let productId = item.dataset.productId;
            let variantId = item.querySelector('.title-with-price .price-wrapper:not(.hidden)')?.dataset.variantId;
            if(document.querySelector(`.custom_widget-products [data-variant-id="${productId}"]`))
              document.querySelector(`.custom_widget-products [data-variant-id="${productId}"]`).value = variantId;
            if(item.querySelector('.title-with-price .price-wrapper:not(.hidden)')?.dataset.inventoryQuantity < 1){
              item.classList.add('hidden');
            }else{
              item.classList.remove('hidden');
            }       
          })
        }

        let currentId = document.querySelector('[data-current-id]').dataset.currentId;
        if(currentId == '10739097352' || currentId == '1965874839615' ){
          if(popoutText == 'Twin'){
            document.querySelector('#zinusPremierRadio--3').classList.add('hidden');
          }else{
            document.querySelector('#zinusPremierRadio--3').classList.remove('hidden');
          }
        }
        document.querySelectorAll('.product-variant__image')?.forEach(element => {
          element.closest('.product-wrapper__item').querySelector('.atc_button').classList.add('hidden');
          element.closest('.product-wrapper__item').querySelector('.shop_now').classList.remove('hidden');
        })
        document.querySelector(`.find-perfect-product [data-product-id="${currentId}"]`)?.querySelector('.shop_now').classList.add('hidden');
        document.querySelector(`.find-perfect-product [data-product-id="${currentId}"]`)?.querySelector('.atc_button').classList.remove('hidden');
        console.log(currentId, 'currentId');
        document.querySelector('.selected_option .option_price').innerHTML = optionPrice;
        document.querySelectorAll('.zinus-perfect-product .price-with-button .variant_price').forEach(item => {
          if(item.dataset.variantTitle.trim().includes(popoutText)){
            item.classList.remove('hidden')
          }else{
            item.classList.add('hidden');
          }
        })
        document.querySelectorAll('.variants-wrapper .variant_item').forEach(variantItem => {
          let variantTitle = variantItem.dataset.variantTitle;
          if(variantTitle.includes(popoutText)){
            let mattressHeight = variantItem.dataset.height;
            let variantID = variantItem.dataset.variantId;
            console.log(variantID, 'variantID');
            document.querySelector('[data-selected-id').dataset.selectedId = variantID;
            let savePrice = variantItem.dataset.savePrice;
            console.log(savePrice, 'savePrice');
            if(!savePrice.includes('$0.00')){
              document.querySelectorAll('.compare_at_price').forEach(item => {
                item.textContent = '+' + savePrice;
              });
            }else{
              document.querySelectorAll('.compare_at_price').forEach(item => {
                item.textContent = '';
              });
            }
            document.querySelectorAll('.mattress-height').forEach(button => {
              button.value = mattressHeight;
            })

            let cross_product = JSON.parse(document.querySelector('.cross_widget [type="application/json"]').textContent);
            let currentSelectedOption = document.querySelector('.select-popout__item--current span').textContent.trim();
            console.log(cross_product, currentSelectedOption, 'cross_product');
            let hide = false;
            cross_product.forEach(variant => {
              if(variant.title.includes(currentSelectedOption)){
                document.querySelector('.cross_widget .product_title').dataset.productId = variant.id;
                let price = (variant.price / 100).toFixed(2);
                document.querySelector('.cross_widget .variant_price').innerHTML = '(+$'+price+')';
                console.log(variant.available, 'variant.available');
                if (variant.available) {
                  hide = true;
                }
              }
            })
            if(document.querySelector('.cross_widget #cross_widget').checked){
              let variantId = document.querySelector('.cross_widget .product_title').dataset.productId;
              document.querySelector('.cross_widget_product').innerHTML = `<input type="hidden" name="items[1][id]" value="${variantId}">`;
            }else{
              document.querySelector('.cross_widget_product').innerHTML = '';
            }

            if(!hide){
              document.querySelector('.cross_widget').classList.add('hidden');
            }else{
              document.querySelector('.cross_widget').classList.remove('hidden');
            }
            
            if(document.querySelector('.product__submit__item.atc_button:not(.hidden)')){
              document.querySelector('.product__submit__item.atc_button:not(.hidden)').closest('.price-with-button').querySelector('[data-product-select]').value = variantID;
            }
            
            if(document.querySelector('.cross_widget #cross_widget').checked){
              let variantId = document.querySelector('.cross_widget .product_title').dataset.productId;
              document.querySelector('.cross_widget_product').innerHTML = `<input type="hidden" name="items[1][id]" value="${variantId}">`;
            }else{
              document.querySelector('.cross_widget_product').innerHTML = '';
            }

            if(!hide){
              document.querySelector('.cross_widget').classList.add('hidden');
            }else{
              document.querySelector('.cross_widget').classList.remove('hidden');
            }

            if(document.querySelector('.product__submit__item.atc_button:not(.hidden)'))
              document.querySelector('.product__submit__item.atc_button:not(.hidden)').closest('.price-with-button').querySelector('[data-product-select]').value = variantID;
            
            if(document.querySelector('.cross_products-wrapper')){
              customWidget(variantID);
            }
          }
          variantTotalPrice.push(variantItem.dataset.totalValue);
        })

        let totalPrice = this.querySelector('.total_price').innerHTML;
        if (!totalPrice.includes('$0.00')) {
          document.querySelector('.selected_option .total_price').innerHTML = totalPrice;
        }

        if(this.closest('.sticky-atc') && window.innerWidth < 767) {
          document.querySelector('.sticky-atc .select-popout__list').classList.add('select-popout__list--visible');
          document.querySelector('.sticky-atc .select-popout__toggle').setAttribute('aria-expanded', true);
        }
        
       
        
      })
    })

    function rebuyOptionSelector(){
      document.querySelectorAll('.cross_product-item')?.forEach(item => {

        item.querySelectorAll('.select-popout__toggle').forEach(button => {
          button.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            if(button.closest('.select-popup__item').querySelector('.select-popout__list').classList.contains('select-popout__list--visible')){
              this.setAttribute('aria-expanded', 'false');
              button.closest('.select-popup__item').querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
            }else{
              this.setAttribute('aria-expanded', 'true');
              button.closest('.select-popup__item').querySelector('.select-popout__list').classList.add('select-popout__list--visible');
            }
          })
        })

        item.querySelectorAll('.item_options .select-popup__item').forEach(itenOption => {
          itenOption.querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(popupItem => {
            popupItem.addEventListener('click', function(e){
              e.preventDefault();
              e.stopPropagation();
              let selectedTitle = popupItem.querySelector('.select-popout__option').dataset.value;
              itenOption.querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(item => {
                item.classList.remove('select-popout__item--current');
              })
              popupItem.classList.add('select-popout__item--current');
              popupItem.closest('.select-popup__item').querySelector('.select-popout__value').textContent = selectedTitle;
              popupItem.closest('.select-popup__item').querySelector('.select-popout__toggle').setAttribute('aria-expanded', 'false');
              popupItem.closest('.select-popup__item').querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
              swatchVariants(item);
            })
          })
        })

        item.querySelectorAll('.item_options .swatch__button').forEach(option => {
          option.querySelector('.swatch__input').addEventListener('click', function(){
            swatchVariants(item);
          })
        })
        
      })
    }

    function swatchVariants(item, filtertext=''){
      let colors = item.querySelectorAll('.item_options .swatch__button');
      let options = [];
      let productUrl = `https://zinus.com/products/${item.dataset.handle}.js`;
      let size = document.querySelector('.select-popout__item--current span')?.textContent.trim();
      let height = item.querySelector('.select-popup__item .select-popout__item--current a')?.dataset.value;
      if(filtertext == 'popup'){
        document.querySelectorAll('.rebuy_popup-wrapper .radio__fieldset').forEach(item => {
          let value = item.querySelector('.variant_radio_input:checked').value;
          options.push(value);
        })
        options.push(size);
      }else{
        colors.forEach(selectedColor => {
          if(selectedColor.querySelector('input[type="radio"]:checked')){
            let color = selectedColor.querySelector('input[type="radio"]:checked').value;
            options.push(color);
          }
        })
        if(height){
          options.push(height);
        }
        if(size){
          options.push(size);
        }
      }
      console.log(options, 'options');
      fetch(productUrl)
          .then(response => {
              if (!response.ok) {
              throw new Error('Network response was not ok ' + response.statusText);
              }
              return response.json();
          })
          .then(data => {
              console.log('Product Information:', data);
              let variantJson = data.variants;
              let currentVariant = variantJson.find((variant) => {
                return !variant.options.map((option, index) => {
                  return options[index] === option;
                }).includes(false);
              });
              let variantPrice = (currentVariant.price / 100).toFixed(2);
              let variantComparePrice = (currentVariant.compare_at_price / 100).toFixed(2);
              console.log(currentVariant, 'currentVariant');
              if(currentVariant.compare_at_price != null){
                item.querySelector('.title-with-price').querySelector('.price-wrapper:not(.hidden) .product__price--compare').textContent = '$'+variantComparePrice;
              }
              item.querySelector('.title-with-price').querySelector('.price-wrapper:not(.hidden)').dataset.variantId = currentVariant.id;
              item.querySelector('.title-with-price').querySelector('.price-wrapper:not(.hidden) .variant_price').textContent = '$'+variantPrice;
              item.closest(`[data-product-part]`).querySelector('.cross_product-details').dataset.variantSku = currentVariant.sku;
              item.closest(`[data-product-part]`).querySelector('[data-product-select]').value = currentVariant.id;
              item.closest(`[data-product-part]`).querySelector('[data-product-select]').dataset.productAvailable = currentVariant.available;
              item.querySelector('.cross_product-image img').src = currentVariant.featured_image.src;
              if(currentVariant.available){
                item.querySelector('.cross_product-checked').disabled = false;
                item.querySelector('.cross_product-checked .icon-plus').classList.remove('hidden');
                item.querySelector('.cross_product-checked .add_button').textContent = 'Add'
              }else{
                item.querySelector('.cross_product-checked').disabled = true;
                item.querySelector('.cross_product-checked .icon-plus').classList.add('hidden');
                item.querySelector('.cross_product-checked .add_button').textContent = 'Sold Out'
              }
            })
          .catch(error => {
              console.error('There was a problem with the fetch operation:', error);
      });
    }

    function popupVariantSwap (){
      document.querySelectorAll('.rebuy_popup-wrapper .cross_product-item')?.forEach(item => {
        item.querySelectorAll('.item_options .swatch__button').forEach(option => {
          option.querySelector('.swatch__input').addEventListener('click', function(){
            swatchVariants(item, 'popup');
          })
        })

        item.querySelectorAll('.item_options .radio__button').forEach(option => {
          option.querySelector('.radio__input').addEventListener('click', function(){
            swatchVariants(item, 'popup');
          })
        })
        
      })
    }

    function quickView(){
      document.querySelector('.cross_products-wrapper').addEventListener('click', function(e){
        let quickViewDescription = '';
        if(!e.target.classList.contains('swatch__label') && !e.target.classList.contains('swatch__input') && !e.target.classList.contains('cross_product-checked')){
            let productHandle = e.target.closest('.cross_product-item').dataset.handle;
            let selectedVariantId =  e.target.closest('[data-product-part]').querySelector('[data-product-select]').value;
            let checkAddButton = '';
            let textButton = '';
            let disabledButton = '';
            let variantTitle = e.target.closest('.cross_product-details').querySelector('.product_title').textContent.trim();
            let variantPrice = e.target.closest('.cross_product-details').querySelector('.variant-with-price .variant_price').dataset.price;
            let variantSku = e.target.closest('.cross_product-details').dataset.variantSku;
            let variantId = e.target.closest('[data-product-part]').querySelector('[data-product-select]').value;
            let container = '.popup-mulberry-inner'
            let selectedColor = e.target.closest('[data-product-part]').querySelector('.variant_radio_input:checked')?.value;
            let selectedSize = e.target.closest('[data-product-part]').querySelector('.select-popout__value')?.textContent;
            let quantityAvailable = e.target.closest('[data-product-part]').querySelector('[data-product-select]').dataset.productAvailable;
            console.log(quantityAvailable, 'quantityAvailable');
            if(quantityAvailable == 'true'){
              textButton = 'Add';
            }else{
              textButton = 'Sold Out'
              disabledButton = 'disabled';
            }
            // if(e.target.closest('.cross_product-item').querySelector('.cross_product-checked').classList.contains('button_clicked')){
            //   checkAddButton = 'button_clicked';
            //   textButton = 'Added';
            // }
            let productsBody = '';
            let getMetafieldsUrl = `https://zinus.com/products/${productHandle}?view=view`;
            fetch(getMetafieldsUrl)
              .then(response => {
                  if (!response.ok) {
                      throw new Error('Network response was not ok: ' + response.statusText);
                  }
                  return response.text(); // Read the response body as text
              })
              .then(data => {
                  quickViewDescription = data;
                  let productUrl = `https://zinus.com/products/${productHandle}.js`;
                  let sizeValue = document.querySelector('.select-popout__item--current span')?.textContent.trim();
                  fetch(productUrl)
                    .then(response => {
                        if (!response.ok) {
                        throw new Error('Network response was not ok ' + response.statusText);
                        }
                        return response.json();
                    })
                    .then(data => {
                        
                        let item = data;
                        console.log(item, 'item');
                        productsBody += `<span class="close_popup"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 192 192"><path d="M150 42 42 150M150 150 42 42" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/></svg></span>
                                <form method="post" action="/cart/add" class="product__form" enctype="multipart/form-data" data-product-form="" data-product-part>
                                  <input type="hidden" name="id" value="${selectedVariantId}" data-product-select="">
                                  <div class="mulberry-id"></div>
                                  <input type="hidden" class="rebuy-attribution" name="properties[_attribution]" value="Rebuy Product" />
                                  <input type="hidden" class="rebuy-source" name="properties[_source]" value="Rebuy" />
                                  <input type="hidden" class="rebuy-widget-id" name="properties[_widget_id]" value="166634" />
                                  <input type="hidden" class="mulberry-product-id" name="properties[mulberry]" value="" />
                                  <div class="cross_product-item" data-product-id="${item.id}" data-handle="${item.handle}">
                                    <div class="rebuy-quick-view__body__inner">
                                      <div class="cross_product-image">
                                        <img src="${item.featured_image}" alt="${item.featured_image.alt}">
                                      </div>
                                    </div>
                                    <div class="cross_product-details">
                                      <label for="cross_product">
                                        <span class='product_title'>${item.title}</span>
                                      </label>
                                      <div class="item_options">`+
                                        item.options.map(option => {
                                          if(option.name.trim() == 'Color'){
                                            let returnText = `<label>${option.name}</label><fieldset class="radio__fieldset">`
                                            for(index in option.values){
                                              let colorName = option.values[index].toLowerCase(); // Change this to any color name you want
                                              let hexValue = getHexValue(dataColors, colorName);
                                              let currentItem = '';
                                              let optionValue = option.values[index].replace(' ', '-');
                                              let input_id = `${option.id}-${option.product_id}-${option.name}-${optionValue}`;
                                              if(option.values[index].trim() == selectedColor.trim()){
                                                currentItem = 'checked';
                                              }
                                              returnText += `<span class="swatch__button"><input type="radio"
                                                class="swatch__input variant_radio_input"
                                                data-single-option-selector
                                                data-index="option"
                                                name="${option.name}"
                                                value="${option.values[index]}"
                                                id="${input_id}"
                                                ${currentItem}>
                                                <label for="${input_id}" class="swatch__label" data-swatch="${option.values[index]}" data-tooltip="${option.values[index]}" style="background-color: ${hexValue};">
                                                <span class="visually-hidden">${option.values[index]}</span>
                                              </label></span>`
                                            }
                                            returnText += `</fieldset>`
                                            return returnText;
                                          }else{
                                            if(option.name.trim() != 'Size'){
                                              let returnText = `<fieldset class="radio__fieldset"><legend class="radio__legend">
                                                  <span class="radio__legend__label">${option.name}</span></legend>`
                                              for(index in option.values){
                                                let currentItem = '';
                                                let optionValue = option.values[index].replace(' ', '-');
                                                let input_id = `${option.id}-${option.product_id}-${option.name}-${optionValue}`;
                                                if(option.values[index].trim() == selectedSize.trim()){
                                                  currentItem = 'checked';
                                                }
                                                returnText += `<span class="radio__button">
                                                    <input
                                                      type="radio"
                                                      class="radio__input variant_radio_input"
                                                      data-single-option-selector
                                                      data-index="option{{ option.position }}"
                                                      name="${option.name}"
                                                      value='${option.values[index]}'
                                                      id="${input_id}"
                                                      ${currentItem}>
                                                    <label for="${input_id}" class="radio__label">
                                                      <span>${option.values[index]}</span>
                                                    </label>
                                                  </span>`
                                              }
                                              returnText += `</fieldset>`
                                              return returnText;
                                            }
                                          }
                                        }).join('')+`
                                      </div>
                                      <div class="title-with-price">`+
                                        item.variants.map((card, index) => {
                                          if(card.id == selectedVariantId){
                                            let option = '';
                                            let hideComparePrice = '';
                                            let variantName = card.title;
                                            let cardPrice = Number(card.price/100).toFixed(2);
                                            if (card.compare_at_price === card.price || !card.compare_at_price) {
                                                hideComparePrice = 'hidden';
                                            }
                                            
                                            return `<div class="price-wrapper ${option}" data-variant-name='${variantName}' data-variant-id="${card.id}" data-inventory-quantity="${card.inventory_quantity}">
                                                        <div class="variant-with-price">
                                                            <span class="sizeValue">(${sizeValue})</span>
                                                            <span class="variant_price" data-price="${cardPrice}">$${cardPrice}</span>
                                                            <span class="product__price--compare ${hideComparePrice}">$${card.compare_at_price}</span>
                                                        </div>
                                                    </div>`;
                                          }
                                        }).join('') + `
                                        <button class="cross_product-checked ${checkAddButton}" type="submit" name="add" data-add-to-cart ${disabledButton}>
                                          <span class="icon-plus">
                                            <svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m13.5113 6.026h-5.53803v-5.538h-1.924v5.538h-5.563996v1.924h5.563996v5.564h1.924v-5.564h5.53803z" fill="currentColor"></path></svg>
                                          </span>
                                          <span class="add_button">${textButton}</span>
                                        </button>
                                      </div>
                                      <div class="popup-mulberry-inner"></div>
                                      <span class="quick_purchase_button">I don't want to protect my purchase</span>
                                      <div class='product_description'>${quickViewDescription}</div>
                                    </div>
                                  </div>
                                </form>`;
                                document.querySelector('.rebuy_popup-wrapper').innerHTML = productsBody;
                                document.querySelector('.popup-overlay').classList.add('active');
                                document.querySelector('body').classList.add('overflow');
                                popupVariantSwap();
                                productPopupWidget();
                                document.querySelector('.close_popup').addEventListener('click', function(){
                                  document.querySelector('.popup-overlay').classList.remove('active');
                                  document.querySelector('body').classList.remove('overflow');
                                })
                                document.querySelector('.quick_purchase_button').addEventListener('click', function(){
                                  document.querySelector('.rebuy_popup-wrapper .mulberry-id').innerHTML = '';
                                  console.log('clicked here');
                                  document.querySelector('.rebuy_popup-wrapper .cross_product-checked').click();
                                })
                      })
                    .catch(error => {
                        console.error('There was a problem with the fetch operation:', error);
                  });
              })
              .catch(error => {
                  console.error('There was a problem with the fetch operation:', error);
            });
            initializeMulberry(variantTitle, variantPrice, variantSku, variantId, container);
          }
      })
    }

    document.querySelector('.select-popout__item--current a').click();

    document.querySelector('.custom_add-button').addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      document.querySelector('.product__submit__holder .product__submit__buttons .product__submit__add').click();
    })

    window.onload = (event) => {
      let stickyATC = document.querySelector('.sticky-atc');
      var formHeight = 0;
      function triggerStickyAtc() {
        let fromBottom = document.querySelector('.product-submit-form').offsetTop + document.querySelector('.product-submit-form').offsetHeight
        if(window.scrollY > fromBottom - 100 && !document.getElementById('SiteHeader').classList.contains('sticky-form')) {
          console.log('netomi first if');
          console.log('netomi SiteHeader: ', !document.getElementById('SiteHeader').classList.contains('sticky-form'))
          document.getElementById('SiteHeader').classList.add('sticky-form');
          document.querySelector('body').classList.add('sticky-add-to-cart');
          stickyATC.appendChild(document.querySelector('.product__title-and-price'));
          stickyATC.appendChild(document.querySelector('.product__form__wrapper'));
          if(window.innerWidth < 767) {
            const netomiIcon = document.querySelector('#netomiChatWindow');
            netomiIcon.style.visibility = 'hidden';
            // netomiIcon.style.bottom = '35%';
          }
          
        }
        if(!document.querySelector('.product-submit-form').querySelector('.product__form__wrapper')) {
          document.querySelector('.product-submit-form').style.minHeight = `${formHeight}px`;
          if(window.innerWidth < 767) {
            console.log('hiding netomi icon');
            const netomiIcon = document.querySelector('#netomiChatWindow');
            netomiIcon.style.visibility = 'hidden';
            console.log('netomiIcon: ', netomiIcon);
            // netomiIcon.style.bottom = '35%';
          }
        }
        else {
          formHeight = document.querySelector('.product-submit-form').querySelector('.product__form__wrapper').offsetHeight;
          document.querySelector('.product-submit-form').style.minHeight = 0;
        }
        if(window.scrollY <= fromBottom - 100 && document.getElementById('SiteHeader').classList.contains('sticky-form')) {
          console.log('netomi SiteHeader: ', !document.getElementById('SiteHeader').classList.contains('sticky-form'))
          document.getElementById('SiteHeader').classList.remove('sticky-form');
          document.querySelector('body').classList.remove('sticky-add-to-cart');
          document.querySelector('.form__wrapper').prepend(document.querySelector('.product__title-and-price'));
          document.querySelector('.product-submit-form').prepend(document.querySelector('.product__form__wrapper'));
          if(window.innerWidth < 767) {
            const netomiIcon = document.querySelector('#netomiChatWindow');
            netomiIcon.style.visibility = 'visible';
            // netomiIcon.style.bottom = '15px';
          }
        }
      }
      window.addEventListener("scroll", (event) => {
        triggerStickyAtc();
      });

      window.NETOMI_WEB_WIDGET.subscribe('MINIMIZE_CHAT_WIDGET', (data) => {
        console.log('netomi widget minimized')
        triggerStickyAtc();
      })

      triggerStickyAtc();
      document.querySelectorAll('.select-popout__item').forEach(item => {
        item.addEventListener('click', function(){
          if(this.classList.contains('sold-out')) {
            document.querySelector('.product__form__wrapper').classList.add('variant--soldout');
            document.querySelectorAll('[data-add-to-cart-text]').forEach(atc => {
              atc.textContent = 'Sold Out - Notify Me When It\'s Available';
            });
            if(document.querySelector('.product__submit__item.atc_button:not(.hidden)'))
              document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('.product__submit__add').disabled = true;
          }
          else {
            document.querySelector('.product__form__wrapper').classList.remove('variant--soldout');
            document.querySelectorAll('[data-add-to-cart-text]').forEach(atc => {
              atc.textContent = 'Add to Cart';
            });
            if(document.querySelector('.product__submit__item.atc_button:not(.hidden)'))
              document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('.product__submit__add').disabled = false;
          }
        });
      });
      document.querySelector('.select-popout__list-close')?.addEventListener('click', function(){
        document.querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
        document.querySelector('.select-popout__toggle').setAttribute('aria-expanded', false);
      });
    };

    function initSwiper(){
      var galleryThumbs = new Swiper(`.product-single__gallery .gallery-thumbs`, {
        centeredSlides: true,
        spaceBetween: 10,
        slideToClickedSlide: true,
        slidesPerView: 8,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });

      var galleryTop = new Swiper(`.product-single__gallery  .gallery-top`, {
        loop: true,
        loopedSlides: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: `.product-single__gallery .swiper-button-next`,
          prevEl: `.product-single__gallery .swiper-button-prev`,
        },
        pagination: {
          el: ".product-single__gallery .swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '" data-pagination-index="'+(index+1)+'"></span>';
          },
        },
      });

      document.querySelector('.product-single__gallery .gallery-thumbs')?.querySelectorAll('.swiper-slide').forEach(slider => {
        slider.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
        let index = this.querySelector('.product-single__thumbnail').dataset.number;
        document.querySelector('.product-single__gallery').querySelector(`[data-pagination-index="`+index+`"`).click();
        })
      })
    }
    function swapProduct(){
      document.querySelectorAll('.swap-product__button').forEach(radioButton => {
        radioButton.addEventListener('change', function(){
          let radioValue = document.querySelector('.zin-radio__button .variant_radio_input:checked ').dataset.value;
          let materialValue = document.querySelector('.zin-material-radio .zin-radio__input:checked').dataset.value;
          let productUrl = '';
          let selectedId = '';
          if(radioValue.includes('Ultra Cooling')){
            radioValue = radioValue.replace('Ultra Cooling', 'Ultra-Cool');
          }
          document.querySelectorAll('.zinus_product').forEach(zinusProduct => {
            let zinusProductTitle = zinusProduct.dataset.productTitle;
            
            if(zinusProductTitle.includes('Ultra Cooling'))
              {
                zinusProductTitle = zinusProductTitle.replace('Ultra Cooling', 'Ultra-Cool');
              }
            if(zinusProductTitle.includes(radioValue) && zinusProductTitle.includes(materialValue)){

              let getVariantData = zinusProduct.querySelector('[type="application/json"]').textContent;
              let sizeOption = document.querySelector('.select-popout__item--current .select-popout__option')?.dataset.value;
              let options = [];
              getVariantData = JSON.parse(getVariantData);
              if(sizeOption)
                options.push(sizeOption);
              let currentVariant = getVariantData.find((variant) => {
                return options[0] === variant.title;
              });
              console.log(currentVariant, 'currentVariant');
              selectedId = currentVariant.id;
              productUrl = zinusProduct.dataset.productUrl+`?variant=${selectedId}`;
            }
          })

          
          console.log(productUrl, 'productUrl');
          window.location.href = productUrl;
        })
      })
    }
    if(document.querySelector('.cross_widget')){
      document.querySelector('.cross_widget #cross_widget').addEventListener('change', function(){
        if(document.querySelector('.cross_widget #cross_widget').checked){
          let variantId = document.querySelector('.cross_widget .product_title').dataset.productId;
          document.querySelector('.cross_widget_product').innerHTML = `<input type="hidden" name="items[1][id]" value="${variantId}">`;
        }else{
          document.querySelector('.cross_widget_product').innerHTML = '';
        }
      })
    }

    /* Custom Buy Now Button Function */

    document.querySelector('.custom-buy-button').addEventListener('click', async function(event){
      event.preventDefault(); // Prevent form submission
      let form = document.querySelector('.product__form__wrapper form');
      let hiddenField = form.querySelector('input[name="id"]');
      let variantId = hiddenField.value;

      await window.mulberry.core.init({
        publicToken: 'zLHKJyjbN1MyxRnXHwSvcgq-gMk'
      });

      const { settings } = mulberry.core
      
      // Fetch variant object
      let variantResponse = await fetch(`/variants/${variantId}.json`);
      let product = await variantResponse.json();
      // Fetch warranty offers
      let offers = await mulberry.core.getWarrantyOffer({
        id: product.product_variant.sku,
        title: 'Cooling Green Tea Memory Foam Mattress',
        price: product.product_variant.price
      });

      console.log(offers, 'offers');
      
      // Initialize the modal
      try  {
        await window.mulberry.modalTrigger.init({
          offers,
          settings: settings,
          trigger: '.mulberry-modal-trigger-1',
          onWarrantyDecline: () => {
            mulberry.modal.close();
            let selectedId = document.querySelector('[data-selected-id').dataset.selectedId;
            addToCart('', selectedId);
          },
          onWarrantySelect: (warranty) => {
            console.log('onWarrantySelect 1', warranty);
            MulberrySelectedWarranty(warranty);
          }
        })
      } catch (e) {
        console.log("Error==>", e);
      } finally {
        console.log("Function has been invoked");
        document.querySelector('.mulberry-modal-trigger').click();
      }
    })

    async function MulberrySelectedWarranty(warranty){
      let mulberrySelectedWarranty = warranty;
      if (mulberrySelectedWarranty) {
        try {
          // Prepare the request parameters
          const params = new URLSearchParams({
            product_price: mulberrySelectedWarranty.product.price,
            duration_months: mulberrySelectedWarranty.duration_months,
            insurer_category: mulberrySelectedWarranty.insurer_category
          });
      
          // Await the fetch call
          const response = await fetch(`https://ottawa.getmulberry.com/api/prices?${params}`, {
            method: 'GET',
            headers: {
              'Authorization': 'Bearer zLHKJyjbN1MyxRnXHwSvcgq-gMk',
              'Content-Type': 'application/json' // Optional
            }
          });
      
          // Check if the response is OK
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
      
          // Await the JSON parsing
          const data = await response.json();
          const shopifyMulberryVariantId = data.shopify_variant_id;
          let selectedId = document.querySelector('[data-selected-id').dataset.selectedId;
          addToCart(shopifyMulberryVariantId, selectedId);
        } catch (error) {
          console.error('Unable to fetch mulberry variant ID', error);
        }
      }
    }

    function addToCart(mulberryId, variantId){
      let formData = [];
      if(mulberryId){
        formData = {
          'items': [
            {
            'id': variantId,
            'quantity': 1
            },
            {
              'id': mulberryId,
              'quantity': 1
            }
          ]
        }
      }else{
        formData = {
          'items': [
            {
            'id': variantId,
            'quantity': 1
            }
          ]
        }
      }
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(function(json) {
        console.log(json, 'json');
        window.location.href = '/checkout';
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
      
  });